import { useEffect, useRef, useState } from 'react';
import { inject, observer } from 'mobx-react';
import { GlobalTracker } from '@/utils/Tracker';
import { querySelector, toggleGlobalScroll } from '@/utils';
import ContactPopupTip from '../ContactPopupTip';
import styles from './index.module.less';
import { AVATAR, YELLOW_AVATAR_LIST } from '@/const/customerService';

// eslint-disable-next-line no-unused-vars
const defaultIcon = 'https://res.insta360.com/static/1bc67bea21f7f54f633559b244e310e3/ic.svg';

const IC_Lang = {
  'en_US': 'en',
  'ja_JP': 'ja',
  'ko_KR': 'ko',
  'es_ES': 'es',
  'it_IT': 'it',
  'de_DE': 'de',
  'fr_FR': 'fr',
};

/**
 * 参考文档：https://developers.intercom.com/installing-intercom/web/installation/
 */
const Intercom = (props) => {
  const {
    app: { G_IsProductPage, isMobile },
    area: {
      country: { code, language },
    },
  } = props;
  const [isConsulting, setIsConsulting] = useState(false);
  const avatar = YELLOW_AVATAR_LIST.includes(code) ? AVATAR.YELLOW : AVATAR.WHITE;
  const contactPopupTipRef = useRef(null);

  const init = () => {
    if (window.Intercom) return;
    console.log('Intercom init');

    window.intercomSettings = Object.assign(
      {},
      {
        app_id: 'uoyosxqi',
        language_override: IC_Lang[language] || 'en',
        custom_launcher_selector: '#intercomLauncher',
        hide_default_launcher: true, // todo 隐藏默认launcher，采用自定义launcher
        alignment: 'right',
        horizontal_padding: 24, // 聊天弹窗的距离
        vertical_padding: 48,
      },
      window.intercomSettings
    );

    const ic = document.createElement('script');
    ic.src = 'https://widget.intercom.io/widget/uoyosxqi';
    ic.onload = function () {
      console.log('Intercom loaded');

      if (window?.Intercom) {
        // 订阅事件，打开弹窗、关闭弹窗时样式变动，设置intercom用户名等
        window.Intercom('onShow', () => {
          document.querySelector('html').classList.add('intercom-ofv');
          setIsConsulting(true);
          if (isMobile) {
            toggleGlobalScroll(true, { hasIntercom: false });
          }
          GlobalTracker.CustomService({ action: 'intercom_body_expose', label: `${code}_${language}` });
          props.auth.initIntercom();
        });
        window.Intercom('onHide', () => {
          querySelector('#fixedToolBar').then((dom) => {
            dom.style.opacity = 1;
          });
          if (isMobile) {
            toggleGlobalScroll(false, { hasIntercom: false });
          }
          document.querySelector('html').classList.remove('intercom-ofv');
          setIsConsulting(false);
          GlobalTracker.CustomService({ action: 'intercom_body_close', label: `${code}_${language}` });
        });
      }
    };
    document.head.appendChild(ic);
  };

  useEffect(() => {
    window.addEventListener('InstaUserActive', () => {
      init();
    });

    // 移动端延迟1s后自动加载（避免首次交互就是点击按钮的情况）
    setTimeout(init, 1500);

    window.loadIntercom = init;
  }, []);

  const onClick = () => {
    window.Intercom &&
      querySelector('#fixedToolBar').then((dom) => {
        dom.style.opacity = 0;
      });
    contactPopupTipRef.current?.onHide('hover');
    GlobalTracker.CustomService({
      action: `intercom_icon_click${isConsulting ? '_close' : ''}`,
      label: `${code}_${language}`,
    });
  };

  const onMouseEnter = () => {
    if (isMobile) return;
    contactPopupTipRef.current?.onShow('hover');
    init();
  };

  const onMouseLeave = () => {
    contactPopupTipRef.current?.onHide('hover');
  };

  return (
    <div data-type='button' className={styles.intercomWrap} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      <ContactPopupTip ref={contactPopupTipRef} tracker='intercom' disabled={isConsulting} />
      <button id='intercomLauncher' className={styles.intercom} data-p={G_IsProductPage} onClick={onClick}>
        <img className={styles.colorAvatar} src={avatar} alt='' />
        {/* <img className={styles.avatar} src={defaultIcon} alt='' /> */}
      </button>
    </div>
  );
};

export default inject('area', 'app', 'auth')(observer((props) => <Intercom {...props} />));
